// While the reader's finger or iOS momentum is moving the chat, nothing may change height:
// WebKit ignores scroll corrections during momentum, so a card that grew mid-flick pushed
// the text you were reading (29 Sep 2026). MessageList reports scroll/touch activity; late
// content (the updates cards) waits for ~180 ms of stillness, lands at once, and the
// reading anchor then corrects instantly while nothing is moving.
const IDLE_MS = 180;
let busyUntil = 0;
let timer: ReturnType<typeof setTimeout> | undefined;
const waiters = new Set<() => void>();

function flush() {
  timer = undefined;
  const wait = busyUntil - Date.now();
  if (wait > 0) { timer = setTimeout(flush, wait + 10); return; }
  const run = [...waiters];
  waiters.clear();
  for (const fn of run) fn();
}

/** The chat is being scrolled or touched right now. */
export function markScrolling() {
  busyUntil = Date.now() + IDLE_MS;
  if (waiters.size && !timer) timer = setTimeout(flush, IDLE_MS + 10);
}

/** Run now if the chat is still, otherwise as soon as scrolling settles. */
export function whenScrollIdle(fn: () => void) {
  if (Date.now() >= busyUntil) { fn(); return; }
  waiters.add(fn);
  if (!timer) timer = setTimeout(flush, busyUntil - Date.now() + 10);
}
